export class Person {
    name?: string;
    lastName?: string;
    phone?: string;
    mobile?: string;
    address?: string;
    user_uid?: string;
    email?: string;
}